import type { LeadboxerInstance } from "./types";

export type LeadboxerBrand = {
  id: LeadboxerInstance;
  labelKey: string;
  fallback: string;
};

export const LEADBOXER_BRANDS: LeadboxerBrand[] = [
  { id: "gobo-dk", labelKey: "crm.visitor_insights.brands.gobo_dk", fallback: "Gobo DK" },
  { id: "gobo-se", labelKey: "crm.visitor_insights.brands.gobo_se", fallback: "Gobo SE" },
  { id: "gobo-fi", labelKey: "crm.visitor_insights.brands.gobo_fi", fallback: "Gobo FI" },
  {
    id: "gobo-light",
    labelKey: "crm.visitor_insights.brands.gobo_light",
    fallback: "Gobo Light Solution",
  },
  {
    id: "ljusdesign",
    labelKey: "crm.visitor_insights.brands.ljusdesign",
    fallback: "Ljusdesign",
  },
];

export const VISITOR_INSIGHT_PERIODS = [
  { labelKey: "crm.visitor_insights.period.last_24h", fallback: "Last 24 Hours", value: 1 },
  { labelKey: "crm.visitor_insights.period.last_3d", fallback: "Last 3 Days", value: 3 },
  { labelKey: "crm.visitor_insights.period.last_7d", fallback: "Last 7 Days", value: 7 },
  { labelKey: "crm.visitor_insights.period.last_30d", fallback: "Last 30 Days", value: 30 },
] as const;
